import { Link, styled } from '@mui/material';

export const LinkStyled = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  padding: '8px 24px',
  borderRadius: '5px',
  backgroundColor: theme.palette.colors.highlight,
  marginTop: '32px',
  color: theme.palette.colors.onImageBackground,
  fontSize: '11px',
  fontWeight: 700,
  textTransform: 'uppercase',

  '&:hover': {
    backgroundColor: theme.palette.colors.hoverHighlight,
  },

  [theme.breakpoints.up('sm')]: {
    fontSize: '12px',
    padding: '8px 35px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '13px',
    padding: '10px 45px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px',
    padding: '10px 65px',
  },
}));
